import { render } from "./button.vue?vue&type=template&id=44058183"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/production_one/web_head/releases/20260420213208/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__